import env from 'libs/constants/env';
import ThirdScripts from '../enums/third-scripts.enum';
import useLoadDynatrace from './use-load-dynatrace';

const useLoadVendors = () => {
  String(env.IS_DEVELOPMENT) === 'false' &&
    useLoadDynatrace(ThirdScripts.WaitingTime);

};

export default useLoadVendors;
